import { SchoolInfo } from '../../../shared/interfaces/school/SchoolInfo';

export const filterInactiveSchools = (
  schools: SchoolInfo[],
  selectedSchoolId?: number | null,
): SchoolInfo[] =>
  schools.filter((school) => school.active || school.id === selectedSchoolId);
